"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IgnoreAllSpellingErrorsCommand = void 0;
var tslib_1 = require("tslib");
var spell_checker_1 = require("../../../core/spelling/spell-checker");
var spelling_command_base_1 = require("./spelling-command-base");
var IgnoreAllSpellingErrorsCommand = (function (_super) {
    tslib_1.__extends(IgnoreAllSpellingErrorsCommand, _super);
    function IgnoreAllSpellingErrorsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IgnoreAllSpellingErrorsCommand.prototype.isVisible = function (selectedMisspelledInterval) {
        return _super.prototype.isVisible.call(this, selectedMisspelledInterval) && selectedMisspelledInterval.errorInfo.errorType == spell_checker_1.SpellingErrorType.Misspelling;
    };
    IgnoreAllSpellingErrorsCommand.prototype.executeCore = function (state, _options) {
        var selectedMisspelledInterval = state.value;
        this.control.spellChecker.ignoreAll(selectedMisspelledInterval);
        return true;
    };
    return IgnoreAllSpellingErrorsCommand;
}(spelling_command_base_1.SpellingCommandBase));
exports.IgnoreAllSpellingErrorsCommand = IgnoreAllSpellingErrorsCommand;
